// VELO conversion popup #1: Exit-intent 10% off (VIP10). Loaded on every
// page (see snippets/exit-intent-popup.liquid) so the post-redirect
// confirmation toast always works; the offer/eligibility logic below no-ops
// when [data-exit-popup] is absent from the current page (e.g. checkout,
// or a cart where VIP10 is already applied - both suppressed server-side).
(function () {
  var STORAGE_SHOWN = 'velo_exit_popup_shown';
  var STORAGE_SESSION_START = 'velo_session_start';

  var DESKTOP_ELIGIBLE_MS = 10000;
  var MOBILE_ELIGIBLE_MS = 30000;
  var MOBILE_SCROLL_THRESHOLD = 50; // percent

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ---------------------------------------------------------------------
  // Confirmation toast (runs regardless of whether the popup itself is
  // present on this page - see comment in the snippet).
  // ---------------------------------------------------------------------
  (function initToast() {
    var toast = document.querySelector('[data-exit-popup-toast]');
    if (!toast) return;

    var params = new URLSearchParams(window.location.search);
    if (params.get('velo_promo') !== 'vip10') return;

    toast.classList.remove('pointer-events-none', 'opacity-0', 'translate-y-2');
    toast.setAttribute('aria-hidden', 'false');

    // Cosmetic cleanup only: replaces the current history entry's URL to
    // drop the marker param, it does not add/remove any entry, so back/
    // forward navigation is completely unaffected.
    params.delete('velo_promo');
    var cleanQuery = params.toString();
    var cleanUrl = window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + window.location.hash;
    if (window.history && window.history.replaceState) {
      window.history.replaceState(window.history.state, '', cleanUrl);
    }

    window.setTimeout(function () {
      toast.classList.add('opacity-0', 'translate-y-2');
      window.setTimeout(function () {
        toast.classList.add('pointer-events-none');
        toast.setAttribute('aria-hidden', 'true');
      }, 300);
    }, 5000);
  })();

  // ---------------------------------------------------------------------
  // Offer popup (exit-intent / delayed-engagement).
  // ---------------------------------------------------------------------
  var popup = document.querySelector('[data-exit-popup]');
  if (!popup) return;

  if (window.sessionStorage) {
    try {
      if (window.sessionStorage.getItem(STORAGE_SHOWN) === '1') return;
    } catch (e) {
      // sessionStorage unavailable (private mode / disabled) - fail safe by
      // not showing the popup at all rather than risking it every page load.
      return;
    }
  } else {
    return;
  }

  function getSessionStart() {
    try {
      var stored = window.sessionStorage.getItem(STORAGE_SESSION_START);
      if (stored) return parseInt(stored, 10);
      var now = Date.now();
      window.sessionStorage.setItem(STORAGE_SESSION_START, String(now));
      return now;
    } catch (e) {
      return Date.now();
    }
  }

  var sessionStart = getSessionStart();

  var overlay = popup.querySelector('[data-exit-popup-overlay]');
  var panel = popup.querySelector('[data-exit-popup-panel]');
  var closeBtn = popup.querySelector('[data-exit-popup-close]');
  var dismissBtn = popup.querySelector('[data-exit-popup-dismiss]');
  var ctaBtn = popup.querySelector('[data-exit-popup-cta]');
  var liveEl = popup.querySelector('[data-exit-popup-live]');
  var lastFocusedElement = null;
  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function isOpen() {
    return popup.getAttribute('aria-hidden') === 'false';
  }

  function cartIsEmpty() {
    var badge = document.querySelector('[data-cart-count]');
    // No badge found (unexpected markup change) - fail open rather than
    // silently suppressing the offer forever.
    if (!badge) return false;
    return badge.classList.contains('hidden');
  }

  function announce(message) {
    if (!liveEl) return;
    liveEl.textContent = '';
    window.requestAnimationFrame(function () {
      liveEl.textContent = message;
    });
  }

  function openPopup() {
    if (isOpen()) return;
    if (cartIsEmpty()) return;

    try {
      window.sessionStorage.setItem(STORAGE_SHOWN, '1');
    } catch (e) {
      // Ignore - worst case the popup could show again this session.
    }

    lastFocusedElement = document.activeElement;
    popup.classList.remove('pointer-events-none');
    popup.setAttribute('aria-hidden', 'false');
    popup.removeAttribute('inert');
    overlay.classList.remove('pointer-events-none');
    overlay.classList.add('opacity-100');
    panel.classList.remove('pointer-events-none', 'opacity-0', 'scale-95');
    document.body.classList.add('overflow-hidden');
    if (closeBtn) closeBtn.focus();
    announce(panel.querySelector('#ExitPopupTitle') ? panel.querySelector('#ExitPopupTitle').textContent.trim() : '');
    teardownTriggers();
  }

  function closePopup() {
    var wasOpen = isOpen();
    if (!wasOpen) return;
    overlay.classList.remove('opacity-100');
    panel.classList.add('opacity-0', 'scale-95');
    document.body.classList.remove('overflow-hidden');
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
    window.setTimeout(function () {
      popup.classList.add('pointer-events-none');
      overlay.classList.add('pointer-events-none');
      panel.classList.add('pointer-events-none');
    }, 300);
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (dismissBtn) dismissBtn.addEventListener('click', closePopup);
  if (overlay) overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closePopup();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = Array.prototype.slice
      .call(panel.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var activeIndex = focusable.indexOf(document.activeElement);

    if (e.shiftKey) {
      if (activeIndex <= 0) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (activeIndex === -1 || activeIndex === focusable.length - 1) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      var destination = window.location.pathname + window.location.search;
      var separator = destination.indexOf('?') === -1 ? '?' : '&';
      var redirectTo = destination + separator + 'velo_promo=vip10' + window.location.hash;
      closePopup();
      window.location.href = routeRoot.replace(/\/$/, '') + '/discount/VIP10?redirect=' + encodeURIComponent(redirectTo);
    });
  }

  // -----------------------------------------------------------------
  // Trigger state machine.
  // -----------------------------------------------------------------
  var hasFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var timers = [];
  var listeners = [];

  function addListener(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listeners.push({ target: target, type: type, handler: handler, options: options });
  }

  function teardownTriggers() {
    timers.forEach(function (id) { window.clearTimeout(id); });
    timers = [];
    listeners.forEach(function (l) { l.target.removeEventListener(l.type, l.handler, l.options); });
    listeners = [];
  }

  function elapsedMs() {
    return Date.now() - sessionStart;
  }

  if (hasFinePointer) {
    // Desktop/tablet pointer devices: genuine exit intent through the top
    // edge, only once eligible (>=10s on site). Ordinary mouse movement
    // inside the viewport never triggers this - only a mouseout event whose
    // relatedTarget is null and whose clientY is at/above 0 (cursor actually
    // left the browser chrome through the top).
    var desktopEligible = false;

    function armDesktopTrigger() {
      desktopEligible = true;
    }

    var remaining = DESKTOP_ELIGIBLE_MS - elapsedMs();
    if (remaining <= 0) {
      armDesktopTrigger();
    } else {
      timers.push(window.setTimeout(armDesktopTrigger, remaining));
    }

    function handleMouseOut(e) {
      if (!desktopEligible) return;
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 0) return;
      openPopup();
    }

    addListener(document, 'mouseout', handleMouseOut);
  } else {
    // Touch-only devices: no reliable native "the visitor is about to
    // leave" signal exists without fragile hacks (see snippet comment for
    // the full reasoning). Single conservative delayed-engagement trigger:
    // eligible only once >=30s on site AND >=50% scroll depth, shown once.
    var timeEligible = false;
    var scrollEligible = false;
    var scrollTicking = false;

    function maybeShow() {
      if (timeEligible && scrollEligible) openPopup();
    }

    function armTimeEligible() {
      timeEligible = true;
      maybeShow();
    }

    var mobileRemaining = MOBILE_ELIGIBLE_MS - elapsedMs();
    if (mobileRemaining <= 0) {
      timeEligible = true;
    } else {
      timers.push(window.setTimeout(armTimeEligible, mobileRemaining));
    }

    function scrollPercent() {
      var doc = document.documentElement;
      var scrollTop = window.pageYOffset || doc.scrollTop;
      var scrollable = doc.scrollHeight - doc.clientHeight;
      if (scrollable <= 0) return 100;
      return (scrollTop / scrollable) * 100;
    }

    function handleScroll() {
      if (scrollEligible || scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        scrollTicking = false;
        if (scrollPercent() >= MOBILE_SCROLL_THRESHOLD) {
          scrollEligible = true;
          maybeShow();
        }
      });
    }

    addListener(window, 'scroll', handleScroll, { passive: true });
    // Covers the rare case where the page is already scrolled/short enough
    // to satisfy the threshold before any scroll event fires.
    if (scrollPercent() >= MOBILE_SCROLL_THRESHOLD) {
      scrollEligible = true;
    }
  }
})();
